class Authentication {
	hasRole = (rol, user) => {
		if (user.organos.length == 0) {
			return false;
		}
		const userRol = user.organos[0].nombrePerfil.toUpperCase();
		return rol.includes(userRol);
	};
}

export const authentication = new Authentication();
